export const DATA_HOOKS = {
  title: 'title',
  subtitle: 'subtitle',
  suffix: 'suffix',
} as const;
